import { Component, HostBinding, OnInit, ViewChild } from '@angular/core';
import { MatDialog } from '@angular/material/dialog';
import { ImportService } from './import.service';
import { TabsService } from '../home/tabs.service';
import { PromptDialogComponent, PromptDialogData } from '../components/prompt-dialog/prompt-dialog.component';
import { ConfirmDialogComponent } from '../components/confirm-dialog/confirm-dialog.component';

@Component({
	selector: 'common-import',
	templateUrl: './import.component.html',
	styleUrls: ['./import.component.scss'],
	providers: [ImportService]
})
export class ImportComponent implements OnInit {
	@HostBinding('class.import') hostClass = true;
	// @ViewChild('fileInput', { static: true }) fileInput: any; åççè®©æå­¦ä¹ 
	@ViewChild('exp', { static: true })
	exp = true;

	isDisplay0 = true;
	isDisplayflex = true;
	isInfo = false;
	isHidden = false;
	isShowSpan = false;
	// selected = '(SKIP)';
	constructor(public svr: ImportService, public dialog: MatDialog, public tabs: TabsService) {}
	ngOnInit() {
		this.svr.init();
	}

	// éæ©æä»¶æ¶è§¦åæä»¶æäº¤
	uploadFile(files: FileList) {
		this.svr.file = files[0];
	}

	dragoverFile(e: DragEvent) {
		e.preventDefault();
	}
	drop(e: DragEvent) {
		this.svr.file = e.dataTransfer.files[0];
		e.preventDefault();
	}

	// âââ ä¾§è¾¹æ   ä¿¡æ¯æ¾ç¤º11
	hiddenNav() {
		this.isDisplay0 = !this.isDisplay0;
		this.isDisplayflex = !this.isDisplayflex;
		this.isInfo = !this.isInfo;
	}
	changeNullIden() {
		const dialogRef = this.dialog.open(PromptDialogComponent, {
			width: '250px',
			data: {
				title: 'NULLå¼è¯å«ç ',
				prompt: 'å¯¼å¥çæ°æ®ä¸­åºç°è¯å«ç çåå®¹å°è¢«è½¬æ¢ä¸ºNULLå¼',
				value: this.svr.nullIden
			} as PromptDialogData
		});

		dialogRef.afterClosed().subscribe(result => {
			if (result !== undefined) {
				this.svr.nullIden = result;
			}
		});
	}
	clearDialog() {
		const dialogRef = this.dialog.open(ConfirmDialogComponent, {
			width: '360px',
			height: '180px',
			data: `ç¡®å®è¦æ¸é¤æ°æ®?`
		});
		dialogRef.afterClosed().subscribe((result: boolean) => {
			if (result) {
				this.svr.removeTableData();
			}
		});
	}
}
